import type { Site } from '../Site';

export const Woman: Site = {
  id: 'woman',
  analyticsName: 'woman',
  selector: '',
  logo: '',
  label: 'Woman',
  platform: '',
};
